import RadioButton from "../../../common/RadioButton";
import Icon from "../../../common/Icon";
import { formatCurrency } from "../../../../utils/valueFormatting";
import { ShippingRate } from "../../../../reducers/shoppingCartOrder";
import * as styledElements from "./ShippingRateOptionStyles";

const ShippingRateOption = ({
  isSelectable,
  setSelectedRate,
  shippingRate,
}: {
  isSelectable?: boolean;
  setSelectedRate?: (selectedRate: ShippingRate) => void;
  shippingRate: ShippingRate;
}) => {
  return (
    <styledElements.Container>
      {isSelectable && (
        <RadioButton
          id={shippingRate.shippo_rate_object_id}
          onChange={() => setSelectedRate?.(shippingRate)}
          styleProps={{ marginRight: "0.5rem" }}
        />
      )}
      <styledElements.Label htmlFor={shippingRate.shippo_rate_object_id}>
        <Icon
          src={shippingRate.provider_logo_link}
          alt={`${shippingRate.provider} logo`}
          iconDimension={24}
        />
        <styledElements.Name>
          {`${shippingRate.provider} ${shippingRate.service_level_name}`}
          <styledElements.ShipDays>
            (
            {`Estimated ${shippingRate.estimated_days} ${
              shippingRate.estimated_days == 1 ? "day" : "days"
            }`}
            )
          </styledElements.ShipDays>
        </styledElements.Name>
        <styledElements.Currency>
          {formatCurrency(shippingRate.amount, shippingRate.currency)}
        </styledElements.Currency>
      </styledElements.Label>
    </styledElements.Container>
  );
};

export default ShippingRateOption;
